import { gql } from '@apollo/client';

export const GET_RAW_CONFIG = () => gql`
  query gen5Config {
    gen5Config {
      raw
    }
  }
`;
